import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';

class CellWithErrorHandlerClass extends Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    componentDidCatch(error, info) {
        this.setState({hasError: true});
    }

    render() {
        const { t } = this.props;
        if (this.state.hasError) {
            return (
                <td title={t('error_boundary.error_details')}>
                    {t('error_boundary.error_details')}
                </td>
            );
        }

        return this.props.children;
    }
}

export const CellWithErrorHandler = withTranslation()(CellWithErrorHandlerClass);
